import CloseIcon from "@components/alert/Icons/CloseIcon.jsx";
import Button from "antd/lib/button";
import Col from "antd/lib/col";
import Form from "antd/lib/form";
import Input from "antd/lib/input";
import Modal from "antd/lib/modal";
import Row from "antd/lib/row";
import React, { Component } from "react";
import { Translate } from "react-localize-redux";
import styled from "styled-components";
import IdView from "../../../components/idView";
import "./style.sass";

const CodeWrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
`;

const ModalTitle = styled.h3`
	color: var(--main-explosive);
	text-align: center;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.75px;
	margin-bottom: 10px;
`;

const TwoFactorAuthInfo = styled.div`
	color: var(--content-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.25px;
	margin-bottom: 20px;
`;

const QrCodeWrapper = styled.div`
	display: flex;
	margin: 0 auto;
	width: 192px;
	height: 192px;
	margin-bottom: 20px;

	img {
		border-radius: 17px;
	}
`;

const CloseIconWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
`;

export default class ConfirmModal extends Component {
	onFinish(values) {
		this.props.verifyMFAToken(values, () => {
			this.props.handleOnClose();
		});
	}
	copy = () => {
		navigator.clipboard.writeText(this.props.data.secretCode).then(
			function () {
				console.debug("Async: Copying to clipboard was successful!");
			},
			function (err) {
				console.error("Async: Could not copy text: ", err);
			}
		);
	};
	render() {
		const { loading, handleOnClose, data, confirmModalVisible } = this.props;
		return (
			<Translate>
				{({ translate }) =>
					confirmModalVisible ? (
						<div className="confirm-modal-wrap">
							<Modal
								style={{ maxWidth: "100%", top: "60px", margin: 0 }}
								width={"100%"}
								visible={confirmModalVisible}
								footer={false}
								loading={loading}
								onCancel={handleOnClose}>
								<div className="two-factor-auth-modal">
									<ModalTitle className="two-factor-auth-modal-title">
										{translate("ENABLE_2FA")}
									</ModalTitle>
									<TwoFactorAuthInfo>
										{translate("TWO_FACTOR_AUTH_INFO_P")}
									</TwoFactorAuthInfo>
									{data?.qrcode ? (
										<QrCodeWrapper>
											<img
												key={data?.qrcode}
												src={data?.qrcode}
											/>
										</QrCodeWrapper>
									) : (
										<CodeWrapper>
											<IdView id={data?.secretCode} />
										</CodeWrapper>
									)}
									<Form
										hideRequiredMark={true}
										layout="horizontal"
										onFinish={this.onFinish.bind(this)}>
										<Row
											style={{
												alignContent: "center",
												justifyContent: "center",
											}}>
											<Col
												xs={24}
												sm={24}
												md={12}
												style={{ textAlignLast: "center" }}>
												<Form.Item
													name="code"
													rules={[
														{
															required: true,
															message:
																"Please input Verification Code!",
														},
													]}>
													<Input
														className="two-factor-auth-input"
														placeholder={translate("VERIFICATION_CODE")}
													/>
												</Form.Item>
											</Col>
											<Col
												xs={24}
												sm={24}
												md={24}>
												<Form.Item
													style={{
														textAlign: "center",
														margin: "10px 0",
													}}>
													<Button
														type="primary"
														htmlType="submit"
														className="two-factor-auth-enable-btn">
														{translate("VERIFY_CODE")}
													</Button>
												</Form.Item>
											</Col>
										</Row>
									</Form>
									<CloseIconWrapper>
										<CloseIcon onClick={handleOnClose} />
									</CloseIconWrapper>
								</div>
							</Modal>
						</div>
					) : null
				}
			</Translate>
		);
	}
}
